// EXACT copy from original master-sheet utils
export const dateWithoutServerTimezone = dateString => {
  const year = dateString.substr(0, 4);
  const month = dateString.substr(5, 2);
  const day = dateString.substr(8, 2);
  return new Date(year, parseInt(month) - 1, day, 0, 0, 0, 0);
};